import React from 'react'
import Banner from '../components/Banner'
import Navbar from '../components/Navbar';
import Disclaimer from '../components/Disclaimer';

function DisclaimerPage() {
  return (
    <div>
      <Banner />
      <Navbar />
      <Disclaimer />
    </div>
  )
}

export default DisclaimerPage;